(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "prop-types", "react", "react-router-dom", "react-router", "./useLocationHistory", "./useLocationHash", "react/jsx-runtime"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("prop-types"), require("react"), require("react-router-dom"), require("react-router"), require("./useLocationHistory"), require("./useLocationHash"), require("react/jsx-runtime"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.propTypes, global.react, global.reactRouterDom, global.reactRouter, global.useLocationHistory, global.useLocationHash, global.jsxRuntime);
    global.StackRouter = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _propTypes, _react, _reactRouterDom, _reactRouter, _useLocationHistory, _useLocationHash, _jsxRuntime) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.StackRouter = StackRouter;
  _propTypes = _interopRequireDefault(_propTypes);
  var _excluded = ["children"],
      _excluded2 = ["children"];

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

  function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

  function StackRouterExtend(_ref) {
    var children = _ref.children,
        props = _objectWithoutProperties(_ref, _excluded);

    var routerContext = (0, _react.useContext)(_reactRouter.__RouterContext);
    var locationHistory = (0, _useLocationHistory.useLocationHistory)();
    (0, _useLocationHash.useLocationHash)(locationHistory);
    routerContext.history.direction = locationHistory.direction;

    var contextValue = _objectSpread(_objectSpread({}, routerContext), {}, {
      locationHistory: locationHistory
    });

    var Provider = _reactRouter.__RouterContext.Provider;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(Provider, {
      value: contextValue,
      children: children
    });
  }

  function StackRouter(_ref2) {
    var children = _ref2.children,
        props = _objectWithoutProperties(_ref2, _excluded2);

    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.BrowserRouter, _objectSpread(_objectSpread({}, props), {}, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StackRouterExtend, {
        children: children
      })
    }));
  }

  StackRouter.propTypes = StackRouterExtend.propTypes = {
    children: _propTypes.default.node
  };
});